// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root___WeNt","icon":"SortAdornment_icon__1Hyxd","up":"SortAdornment_up__3R2-d","down":"SortAdornment_down__3s61I","active":"SortAdornment_active__s5GAX"};